const AUDIO_EXTENSION_PATTERN = /\.(mp3|wav|ogg|oga|opus|flac|m4a|aac|aiff?|caf|amr)(\?|$)/i
const MODEL_EXTENSION_PATTERN = /\.(obj|glb|gltf|stl)(\?|$)/i
const PAYLOAD_KINDS = new Set(['image', 'video', 'audio', 'file', 'run'])

// Payload rendering and static geometry must classify the same object the same way. In
// particular, audio extensions win over video/mp4 because m4a files are commonly mislabeled.
export function payloadMediaKind(output = {}) {
    const url =
        output?.url ||
        output?.preview_url ||
        output?.urls?.original ||
        output?.urls?.medium ||
        output?.urls?.small ||
        ''
    const fileName = output?.name || output?.filename || output?.original_filename || ''
    if (AUDIO_EXTENSION_PATTERN.test(url) || AUDIO_EXTENSION_PATTERN.test(fileName)) {
        return 'audio'
    }

    const declaredKind = output?.kind
    if (PAYLOAD_KINDS.has(declaredKind)) return declaredKind

    const declaredType = output?.type
    if (PAYLOAD_KINDS.has(declaredType)) return declaredType

    if (MODEL_EXTENSION_PATTERN.test(url) || MODEL_EXTENSION_PATTERN.test(fileName)) {
        return 'file'
    }

    const contentType = String(
        output?.mime || output?.content_type || output?.contentType || output?.type || '',
    ).toLowerCase()
    if (contentType.startsWith('image/')) return 'image'
    if (contentType.startsWith('video/')) return 'video'
    if (contentType.startsWith('audio/')) return 'audio'
    return 'file'
}

// Images and videos share one rendered payload row. Keep that layout classification separate
// from the underlying media kind so callers can still choose the correct player/renderer.
export function payloadMediaRowKind(kind) {
    return kind === 'image' || kind === 'video' ? 'visual' : kind
}
